import { AgGridAngular } from '@ag-grid-community/angular';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import {
  Component,
  ViewChild,
  ViewEncapsulation,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { agGridLocale } from 'app/utils/ag-grid.locale';
import { PayrollExtraEntry } from 'app/api/payroll.extra.api.service';
import * as _ from 'lodash';
import { AppState } from 'app/reducers';
import { Store } from '@ngrx/store';
import { PayrollExtraActions } from '../../actions';
@Component({
  selector: 'app-payroll-settings',
  templateUrl: './payroll-settings.component.html',
  styleUrls: ['./payroll-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PayrollSettingsComponent implements OnChanges {
  public gridApi;
  public gridColumnApi;

  public columnDefs;
  public context;
  public defaultColDef;
  public statusBar;
  public localeText;
  public modules;
  public editType = '';
  public rowSelection = 'single';
  public getRowNodeId;
  public floatingFilter = false;
  public deltaRowDataMode = true;
  public rowDragManaged = true;
  public suppressRowDrag = true;

  public sortChanged = false;

  selectedRow: { choice: string };
  rowData: { choice: string }[] = [];

  @Input() extraSelected: PayrollExtraEntry;

  @ViewChild('agGridPayrollExtraSettings', { static: false })
  agGrid: AgGridAngular;

  constructor(
    protected store: Store<AppState>
  ) {
    this.modules = AllModules;
    this.localeText = agGridLocale.fr;
    this.columnDefs = this.getColumnDefs();
    this.defaultColDef = {
      enableValue: true,
      sortable: true,
      filter: true,
      resizable: true,
    };
    this.statusBar = {
      statusPanels: [
        {
          statusPanel: 'agTotalRowCountComponent',
          align: 'left',
        },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agFilteredRowCountComponent' },
      ],
    };
    this.context = { componentParent: this };
    this.getRowNodeId = (data) => data.choice;
  }

  ngOnChanges(simpleChange: SimpleChanges): void {
    if (simpleChange.extraSelected.previousValue) {
      this.extraSelected = simpleChange.extraSelected.currentValue;
      this.initAgGrid();
    }
  }

  getColumnDefs(): any[] {
    return [
      {
        headerName: '',
        field: 'choice',
        editable: true,
      },
    ];
  }

  onGridReady(params: { api: any; columnApi: any }): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    if (this.extraSelected) {
      this.initAgGrid();
    }
  }

  initAgGrid(): void {
    const { choices, name } = this.extraSelected;
    const choicesList = choices ? choices.split('|') : [];
    this.rowData = choicesList.map((value) => {
      return { choice: value };
    });
    this.columnDefs = this.getColumnDefs();
    this.columnDefs[0].headerName = `${name}`;

    if (this.rowData.length === 0){
      this.rowData.push({ choice: '-- Nouveau --' });
    }
    this.gridApi.setRowData(this.gridApi.rowData);
  }

  onFirstDataRendered(params): void {
    // this.autoSizeAll(params);
  }

  onToggleChange(): void {
    // this.suppressRowDrag = !this.suppressRowDrag;
    // this.gridApi.setSuppressRowDrag(this.suppressRowDrag);
  }

  onGroupCellClick(data: any, isChecked: boolean): void {
    this.onCellValueChanged({ data });
  }

  onCellValueChanged(ev: any): void {
    const data = ev.data as string;
    if (data) {
      const newData = this.rowData.map((d) => d.choice).join('|');
      this.extraSelected.choices = newData;
      this.store.dispatch(
        PayrollExtraActions.payrollExtraUpdateOneRequested({ input: this.extraSelected })
      );
    }
    this.selectedRow = null;
    ev.api.deselectAll();
  }

  onRowDragEnd(ev: any): void {
    this.sortChanged = true;
  }

  onSelectionChanged(): void {
    const selectedRows = this.gridApi.getSelectedRows();
    if (selectedRows.length === 1) {
      this.selectedRow = selectedRows[0];
    } else {
      this.selectedRow = null;
    }
  }

  onRowDataUpdated(ev: any): void {
    // this.gridApi.forEachNode((node) => {
    //   if (node.data.name === '-- Nouveau --') {
    //     node.setSelected(true);
    //     this.gridApi.startEditingCell({
    //       rowIndex: node.rowIndex,
    //       colKey: 'name',
    //     });
    //   }
    // });
  }

  onCreate(): void {
    this.extraSelected.choices = this.extraSelected.choices + '|-- Nouveau --';
    this.store.dispatch(
      PayrollExtraActions.payrollExtraUpdateOneRequested({ input: this.extraSelected })
    );
    this.selectedRow = null;
    this.initAgGrid();
  }

  onDelete(): void {
    const selectedRows = this.gridApi.getSelectedRows();
    if (selectedRows.length === 1) {
      const row = selectedRows[0] as { choice: string };
      let newData: any = _.filter(this.rowData, d => d.choice !== row.choice);
      newData = newData.map((d) => d.choice).join('|');

      if (this.rowData.length === 0) {
        newData = null;    
      }

      this.extraSelected.choices = newData;

      this.store.dispatch(
        PayrollExtraActions.payrollExtraUpdateOneRequested({
          input: this.extraSelected
        })
      );
      this.initAgGrid();
      this.selectedRow = null;
    }
  }

  onCancelSort(): void {
    // const query = {
    //   companyId: this.company.id,
    //   key: { beginsWith: 'ana1' },
    // };
    // this.store.dispatch(AnalyticsActions.analyticsRequested({ query }));
    // this.sortChanged = false;
  }

  onSaveSort(): void {
    // if (this.sortChanged) {
    //   const input: UpdateAnalyticsEntrySortInput[] = [];
    //   this.gridApi.forEachNode((node) => {
    //     if (node.data) {
    //       const data = node.data as AnalyticsEntry;
    //       if (data.sortOrder !== node.rowIndex + 1) {
    //         input.push({
    //           companyId: data.companyId,
    //           key: data.key,
    //           sortOrder: node.rowIndex + 1,
    //         });
    //       }
    //     }
    //   });
    //   if (input.length > 0) {
    //     const query = {
    //       companyId: this.company.id,
    //       key: { beginsWith: 'ana1' },
    //     };
    //     this.store.dispatch(
    //       AnalyticsActions.analyticsSortEntriesRequested({ query, input })
    //     );
    //   }
    //   this.sortChanged = false;
    // }
  }

  // private autoSizeAll(params: any): void {
  //   const allColumnIds = params.columnApi
  //     .getAllColumns()
  //     .map((column) => column.colId);
  //   params.columnApi.autoSizeColumns(allColumnIds);
  // }
}
